/* Share Your Shed form logic.
 * - Lazily starts a submission session (POST /api/share/start) on first interaction.
 * - Uploads files straight from the browser to cloud storage via window.CRBBlobUpload
 *   (bundled @vercel/blob/client) with per-file progress bars.
 * - Auto-saves text fields to localStorage so nothing is lost if an upload fails.
 * - Submits to /api/share/submit; server-side validation errors map back to fields.
 */
(function () {
  "use strict";

  var root = document.querySelector(".crb-share");
  var form = document.getElementById("crb-share-form");
  if (!root || !form) return;

  var API = (root.getAttribute("data-api-base") || "").replace(/\/+$/, "");
  var SAVE_KEY = "crb-share-shed-v1";
  var IMAGE_TYPES = ["image/jpeg", "image/png", "image/heic", "image/heif", "image/webp"];
  var VIDEO_TYPES = ["video/mp4", "video/quicktime", "video/x-m4v"];

  var state = {
    token: null,
    starting: null, // in-flight start promise
    limits: { maxPhotos: 30, maxVideos: 5, maxVideoBytes: 2147483648, maxPhotoBytes: 52428800, maxTotalBytes: 5368709120 },
    files: [], // { id, kind, filename, size, url, pct, error, objectUrl }
    submitting: false
  };
  var uid = 0;

  var statusEl = document.getElementById("cs-status");
  var formErr = document.getElementById("cs-form-err");

  /* ---------- session ---------- */

  function ensureSession() {
    if (state.token) return Promise.resolve(state.token);
    if (state.starting) return state.starting;
    state.starting = fetch(API + "/api/share/start", { method: "POST" })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        if (!json.ok) throw new Error(json.error || "Could not start. Please try again.");
        state.token = json.token;
        if (json.limits) state.limits = json.limits;
        return state.token;
      })
      .catch(function (e) { state.starting = null; throw e; });
    return state.starting;
  }

  /* ---------- autosave ---------- */

  var TEXT_FIELDS = ["firstName", "lastName", "email", "phone", "city", "state", "purchaseYear",
    "buildingUse", "buildingSize", "buildingStyle", "sidingType", "colors", "salesLot",
    "story", "mediaLink", "contactPreference", "socialLinks", "suggestedTitle", "street"];

  function saveDraft() {
    try {
      var data = { _files: state.files.filter(function (f) { return f.url; }).map(function (f) {
        return { kind: f.kind, filename: f.filename, url: f.url, size: f.size };
      }) };
      TEXT_FIELDS.forEach(function (n) { var el = form.elements[n]; if (el) data[n] = el.value; });
      localStorage.setItem(SAVE_KEY, JSON.stringify(data));
    } catch (e) { /* storage full or blocked: fine */ }
  }

  function restoreDraft() {
    var raw;
    try { raw = localStorage.getItem(SAVE_KEY); } catch (e) { return; }
    if (!raw) return;
    try {
      var data = JSON.parse(raw);
      TEXT_FIELDS.forEach(function (n) {
        var el = form.elements[n];
        if (el && data[n]) el.value = data[n];
      });
      (data._files || []).forEach(function (f) {
        var item = { id: "r" + (uid++), kind: f.kind, filename: f.filename, size: f.size || 0, url: f.url, pct: 100 };
        state.files.push(item);
        renderFile(item);
      });
    } catch (e) { /* corrupt draft: ignore */ }
  }

  form.addEventListener("input", debounce(saveDraft, 400));

  function debounce(fn, ms) {
    var t; return function () { clearTimeout(t); t = setTimeout(fn, ms); };
  }

  /* ---------- file handling ---------- */

  function listFor(kind) {
    if (kind === "video") return document.getElementById("cs-video-list");
    if (kind === "before_photo" || kind === "after_photo") return document.getElementById("cs-ba-list");
    return document.getElementById("cs-photo-list");
  }

  function counts() {
    var photos = 0, videos = 0, bytes = 0;
    state.files.forEach(function (f) {
      if (f.error) return;
      if (f.kind === "video") videos++; else photos++;
      bytes += f.size || 0;
    });
    return { photos: photos, videos: videos, bytes: bytes };
  }

  function fmtMB(bytes) { return (bytes / 1048576).toFixed(1) + " MB"; }

  function renderFile(item) {
    var li = document.createElement("li");
    li.id = "csf-" + item.id;
    var thumb;
    if (item.objectUrl) {
      thumb = document.createElement("img");
      thumb.src = item.objectUrl;
      thumb.alt = "";
    } else {
      thumb = document.createElement("span");
      thumb.className = "crb-share__file-icon";
      thumb.textContent = item.kind === "video" ? "🎥" : "📷";
    }
    var meta = document.createElement("span");
    meta.className = "crb-share__file-meta";
    var name = document.createElement("span");
    name.className = "crb-share__file-name";
    name.textContent = item.filename + (item.size ? " (" + fmtMB(item.size) + ")" : "");
    var bar = document.createElement("span");
    bar.className = "crb-share__bar";
    bar.innerHTML = '<span class="crb-share__bar-fill"></span>';
    meta.appendChild(name);
    meta.appendChild(bar);
    var x = document.createElement("button");
    x.type = "button";
    x.className = "crb-share__file-x";
    x.setAttribute("aria-label", "Remove " + item.filename);
    x.textContent = "✕";
    x.addEventListener("click", function () { removeFile(item.id); });
    li.appendChild(thumb);
    li.appendChild(meta);
    li.appendChild(x);
    listFor(item.kind).appendChild(li);
    updateFileRow(item);
  }

  function updateFileRow(item) {
    var li = document.getElementById("csf-" + item.id);
    if (!li) return;
    var fill = li.querySelector(".crb-share__bar-fill");
    var name = li.querySelector(".crb-share__file-name");
    if (item.error) {
      li.style.background = "#f8e8e5";
      name.textContent = item.filename + ": " + item.error;
      fill.style.width = "0%";
    } else {
      fill.style.width = (item.pct || 0) + "%";
      fill.style.background = item.pct >= 100 ? "#3d5c3a" : "#8aa984";
      name.textContent = item.filename + (item.size ? " (" + fmtMB(item.size) + ")" : "") +
        (item.pct >= 100 ? " ✓" : item.pct > 0 ? " " + item.pct + "%" : "");
    }
  }

  function removeFile(id) {
    var idx = state.files.findIndex(function (f) { return f.id === id; });
    if (idx === -1) return;
    var item = state.files[idx];
    if (item.objectUrl) URL.revokeObjectURL(item.objectUrl);
    state.files.splice(idx, 1);
    var li = document.getElementById("csf-" + id);
    if (li) li.remove();
    saveDraft();
    announce("Removed " + item.filename + ".");
  }

  function announce(msg) { if (statusEl) statusEl.textContent = msg; }

  function addFiles(fileList, kind) {
    var files = Array.prototype.slice.call(fileList || []);
    if (!files.length) return;
    var errBox = document.getElementById("cs-photos-err");
    errBox.hidden = true;

    files.forEach(function (file) {
      var isVideo = kind === "video";
      var type = file.type || "";
      var okType = isVideo
        ? (VIDEO_TYPES.indexOf(type) !== -1 || /\.(mov|mp4|m4v)$/i.test(file.name))
        : (IMAGE_TYPES.indexOf(type) !== -1 || /\.(jpe?g|png|heic|heif|webp)$/i.test(file.name));
      if (!okType) return fail(file, isVideo ? "That video type is not supported (MP4 or MOV works)." : "That file type is not supported (JPG, PNG, HEIC, or WebP works).");

      var c = counts();
      if (isVideo && c.videos >= state.limits.maxVideos) return fail(file, "Up to " + state.limits.maxVideos + " videos.");
      if (!isVideo && c.photos >= state.limits.maxPhotos) return fail(file, "Up to " + state.limits.maxPhotos + " photos.");
      var maxBytes = isVideo ? state.limits.maxVideoBytes : state.limits.maxPhotoBytes;
      if (file.size > maxBytes) return fail(file, "Too big (limit " + Math.round(maxBytes / 1048576) + " MB).");
      if (c.bytes + file.size > state.limits.maxTotalBytes) return fail(file, "This submission has hit its total size limit.");

      var item = {
        id: "f" + (uid++),
        kind: kind,
        filename: file.name,
        size: file.size,
        pct: 0,
        objectUrl: /^image\/(jpeg|png|webp)$/.test(type) ? URL.createObjectURL(file) : null
      };
      state.files.push(item);
      renderFile(item);
      startUpload(item, file);
    });

    function fail(file, why) {
      errBox.textContent = file.name + ": " + why;
      errBox.hidden = false;
    }
  }

  /* HEIC photos (iPhone default) don't display in most browsers, so convert
   * them to JPEG in the browser before upload. The converter script is heavy,
   * so it loads only when a HEIC file is actually picked. */
  var heicLoader = null;
  function loadHeic() {
    if (window.CRBHeic) return Promise.resolve();
    if (heicLoader) return heicLoader;
    heicLoader = new Promise(function (resolve, reject) {
      var s = document.createElement("script");
      s.src = root.getAttribute("data-heic-src") || "";
      s.onload = function () { resolve(); };
      s.onerror = function () { heicLoader = null; reject(new Error("Could not load the photo converter.")); };
      document.head.appendChild(s);
    });
    return heicLoader;
  }

  function isHeic(file) {
    return /image\/hei[cf]/.test(file.type || "") || /\.hei[cf]$/i.test(file.name);
  }

  function prepareFile(item, file) {
    if (!isHeic(file)) return Promise.resolve(file);
    announce("Getting " + item.filename + " ready...");
    return loadHeic()
      .then(function () { return window.CRBHeic.convert({ blob: file, toType: "image/jpeg", quality: 0.85 }); })
      .then(function (out) {
        var blob = Array.isArray(out) ? out[0] : out;
        var name = item.filename.replace(/\.hei[cf]$/i, "") + ".jpg";
        var converted = new File([blob], name, { type: "image/jpeg" });
        item.filename = name;
        item.size = converted.size;
        item.objectUrl = URL.createObjectURL(converted);
        var li = document.getElementById("csf-" + item.id);
        if (li) {
          var icon = li.querySelector(".crb-share__file-icon");
          if (icon) {
            var img = document.createElement("img");
            img.src = item.objectUrl;
            img.alt = "";
            icon.replaceWith(img);
          }
        }
        updateFileRow(item);
        return converted;
      })
      .catch(function () {
        // If conversion fails, upload the original HEIC; staff can still use it.
        return file;
      });
  }

  function startUpload(item, file) {
    announce("Uploading " + item.filename + "...");
    Promise.resolve()
      .then(function () { return prepareFile(item, file); })
      .then(function (prepared) { file = prepared; return ensureSession(); })
      .then(function (token) {
        if (!window.CRBBlobUpload) throw new Error("Uploader failed to load. Please refresh the page.");
        return window.CRBBlobUpload.upload("share-your-shed/" + item.filename, file, {
          access: "public",
          handleUploadUrl: API + "/api/share/upload",
          clientPayload: JSON.stringify({ token: token, kind: item.kind }),
          multipart: file.size > 20 * 1048576,
          onUploadProgress: function (p) {
            item.pct = Math.max(1, Math.min(99, Math.round(p.percentage || 0)));
            updateFileRow(item);
          }
        });
      })
      .then(function (blob) {
        item.url = blob.url;
        item.pct = 100;
        updateFileRow(item);
        saveDraft();
        announce(item.filename + " uploaded.");
      })
      .catch(function (e) {
        item.error = (e && e.message) || "Upload failed. Tap ✕ and try again.";
        updateFileRow(item);
        announce(item.filename + " failed to upload. You can remove it and try again.");
      });
  }

  /* ---------- inputs, drag and drop ---------- */

  function wireInput(id, kind) {
    var input = document.getElementById(id);
    if (!input) return;
    input.addEventListener("change", function () {
      addFiles(input.files, kind);
      input.value = ""; // allow re-selecting the same file
    });
  }
  wireInput("cs-photo-input", "photo");
  wireInput("cs-before-input", "before_photo");
  wireInput("cs-after-input", "after_photo");
  wireInput("cs-video-input", "video");

  var drop = document.getElementById("cs-drop");
  if (drop) {
    ["dragenter", "dragover"].forEach(function (ev) {
      drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add("crb-share__drop--drag"); });
    });
    ["dragleave", "drop"].forEach(function (ev) {
      drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove("crb-share__drop--drag"); });
    });
    drop.addEventListener("drop", function (e) {
      if (e.dataTransfer && e.dataTransfer.files) addFiles(e.dataTransfer.files, "photo");
    });
  }

  // Start the session as soon as the visitor touches the form, so uploads are instant.
  form.addEventListener("focusin", function once() {
    form.removeEventListener("focusin", once);
    ensureSession().catch(function () { /* retried on upload/submit */ });
  });

  restoreDraft();

  /* ---------- validation + submit ---------- */

  function setFieldError(name, message) {
    var el = form.elements[name];
    var err = document.getElementById("cs-" + name + "-err");
    if (el && el.setAttribute) el.setAttribute("aria-invalid", message ? "true" : "false");
    if (err) { err.textContent = message || ""; err.hidden = !message; }
  }

  function clearErrors() {
    Array.prototype.forEach.call(form.querySelectorAll(".crb-share__err"), function (e) { e.hidden = true; });
    Array.prototype.forEach.call(form.querySelectorAll("[aria-invalid='true']"), function (e) { e.setAttribute("aria-invalid", "false"); });
    formErr.hidden = true;
  }

  form.addEventListener("submit", function (e) {
    e.preventDefault();
    if (state.submitting) return;
    clearErrors();

    // Client-side checks with friendly messages before we hit the server.
    var required = [
      ["firstName", "Please add your first name."],
      ["lastName", "Please add your last name."],
      ["email", "Please add your email so we can send your page link."],
      ["phone", "Please add your phone number."],
      ["city", "Please add your city."],
      ["purchaseYear", "Please pick the year (a best guess is fine)."],
      ["buildingUse", "Tell us a little about how you use your building."]
    ];
    var firstBad = null;
    required.forEach(function (r) {
      var el = form.elements[r[0]];
      if (el && !el.value.trim()) { setFieldError(r[0], r[1]); if (!firstBad) firstBad = el; }
    });

    var consentBad = ["ownsContent", "mediaRelease", "isAdult"].filter(function (n) { return !form.elements[n].checked; });
    if (consentBad.length) {
      var ce = document.getElementById("cs-consent-err");
      ce.textContent = "Please check all three required agreements.";
      ce.hidden = false;
      if (!firstBad) firstBad = form.elements[consentBad[0]];
    }

    var uploading = state.files.some(function (f) { return !f.error && !f.url; });
    var goodFiles = state.files.filter(function (f) { return f.url; });
    var mediaLink = form.elements.mediaLink.value.trim();
    if (!goodFiles.length && !mediaLink && !uploading) {
      var pe = document.getElementById("cs-photos-err");
      pe.textContent = "Please add at least one photo (or paste a link to your photos below in More details).";
      pe.hidden = false;
      if (!firstBad) firstBad = document.getElementById("cs-photo-input");
    }
    if (firstBad) {
      formErr.textContent = "Almost there! Please fix the highlighted items above.";
      formErr.hidden = false;
      firstBad.focus();
      return;
    }
    if (uploading) {
      formErr.textContent = "Hang tight, your files are still uploading. The button will work as soon as they finish.";
      formErr.hidden = false;
      return;
    }

    state.submitting = true;
    var btn = document.getElementById("cs-submit");
    btn.disabled = true;
    announce("Sending your submission...");

    var payload = {
      website: form.elements.website.value,
      files: goodFiles.map(function (f) { return { url: f.url, kind: f.kind, filename: f.filename }; })
    };
    TEXT_FIELDS.forEach(function (n) { payload[n] = form.elements[n] ? form.elements[n].value.trim() : ""; });
    ["ownsContent", "mediaRelease", "isAdult", "allowPaidAds", "photoVisitOk", "showFirstName", "showCity", "marketingOptIn"]
      .forEach(function (n) { payload[n] = !!(form.elements[n] && form.elements[n].checked); });

    ensureSession()
      .then(function (token) {
        payload.token = token;
        return fetch(API + "/api/share/submit", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        });
      })
      .then(function (r) { return r.json().then(function (j) { return { status: r.status, json: j }; }); })
      .then(function (res) {
        if (res.json && res.json.ok) {
          try { localStorage.removeItem(SAVE_KEY); } catch (err) { /* fine */ }
          form.hidden = true;
          var success = document.getElementById("cs-success");
          success.hidden = false;
          success.setAttribute("tabindex", "-1");
          success.focus();
          announce("Submission received. Thank you!");
          if (window.dataLayer) window.dataLayer.push({ event: "share_shed_submission_completed" });
          return;
        }
        var fe = (res.json && res.json.fieldErrors) || {};
        Object.keys(fe).forEach(function (k) { setFieldError(k, fe[k]); });
        formErr.textContent = (res.json && res.json.error) || "Something went wrong. Please try again.";
        formErr.hidden = false;
        announce("");
      })
      .catch(function () {
        formErr.textContent = "We couldn't reach our server. Your answers are saved on this device; please check your connection and try again.";
        formErr.hidden = false;
      })
      .then(function () {
        state.submitting = false;
        btn.disabled = false;
      });
  });

  if (window.dataLayer) window.dataLayer.push({ event: "share_shed_page_view" });
  form.addEventListener("focusin", function trackStart() {
    form.removeEventListener("focusin", trackStart);
    if (window.dataLayer) window.dataLayer.push({ event: "share_shed_form_started" });
  });
})();
